import React from 'react'
import Reflux from 'reflux'
import { Card, CardHeader, CardBody } from 'reactstrap'

import CurrentRecipeStore from '~/stores/currentRecipe.js'


export default class RecipeInstructionsView extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = CurrentRecipeStore
		this.storeKeys = [
			'recipeInstructions'
		]
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		const hasInstructions = (this.state.recipeInstructions.length > 0)
		const theInstructions = this.state.recipeInstructions.map(theInstruction =>
			<li
				key={theInstruction.recipeInstructionsID}
			>
				{theInstruction.instruction}
			</li>
		)

		return (
			<Card>
				<CardHeader>
					Instructions
				</CardHeader>

				<CardBody>
					{
						hasInstructions === false &&
						<em>{'No instructions have been added for this recipe'}</em>
					}
					{
						hasInstructions === true &&
						<ol>
							{theInstructions}
						</ol>
					}
				</CardBody>
			</Card>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/recipeInstructions/view.jsx